import { Card } from '../ui/primitives';
import { cx } from '../ui/primitives/cx';
import type { QuickAccessItem } from '../../utils/quickAccess';
import { CardHead, Tile } from './InicioParts';

const TITLE_ID = 'inicio-quick-title';

/**
 * Rediseño · Bloque C — «Accesos rápidos» (P-030; B0-05): la lista fija, con «Vender» destacado.
 * Qué accesos hay y quién ve cada uno se decide en `utils/quickAccess.ts`; aquí solo se dibujan.
 * Sin accesos que mostrar, la tarjeta no aparece.
 */
export function InicioQuickAccess({ items, onNavigate }: { items: QuickAccessItem[]; onNavigate: (destination: string) => void }) {
  if (items.length === 0) return null;
  return (
    <Card aria-labelledby={TITLE_ID} as="section">
      <CardHead id={TITLE_ID} title="Accesos rápidos" />
      <div className="n3-inicio__quick">
        {items.map((item) => (
          <button
            className={cx('n3-inicio__quick-item', item.primary && 'n3-inicio__quick-item--primary')}
            key={item.id}
            onClick={() => onNavigate(item.destination)}
            type="button"
          >
            <Tile icon={item.icon} size={item.primary ? 20 : 19} tone={item.primary ? 'brand' : item.tone} />
            <span className="n3-inicio__quick-text">
              <span className="n3-inicio__quick-title">{item.title}</span>
              {item.text && <span className="n3-inicio__quick-detail">{item.text}</span>}
            </span>
          </button>
        ))}
      </div>
    </Card>
  );
}
